export default __webpack_public_path__ + "static/wamo-screens-mobile-4adc8525fa9c98adcf2f3f8985cb4dd7.jpg";